import { Badge } from "@/components/ui/badge";
import { GithubRepositoryRelease } from "@/gql/__generated__/graphql";
import { cn } from "@/lib/utils";
import MDEditor from "@uiw/react-md-editor";
import { format } from "date-fns";

interface Props {
  release: GithubRepositoryRelease;
  isNewRelease?: boolean;
}

export function Release({ release, isNewRelease = false }: Props) {
  return (
    <div
      className={cn(
        "border rounded-md p-4",
        isNewRelease
          ? "border-brand-primary/60 bg-gradient-to-bl from-brand-primary/15 to-brand-primary/10 dark:from-brand-primary/10 dark:to-brand-primary/0"
          : "dark:border-brand-gray-800"
      )}
    >
      <div className="flex gap-2 mt-0 justify-end">
        {isNewRelease && (
          <Badge variant="secondary" className="bg-brand-primary">
            New
          </Badge>
        )}
        <Badge variant="secondary" className="dark:bg-brand-gray-800">
          {release.name}
        </Badge>
        <Badge variant="secondary" className="dark:bg-brand-gray-800">
          {format(release.publishedAt, "PP")}
        </Badge>
      </div>
      <MDEditor.Markdown
        className="bg-transparent text-brand-gray-800 dark:text-brand-gray-50 [&>h2>a]:hidden"
        source={release.body}
      />
    </div>
  );
}
